import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";

export const AudioPlayer = forwardRef(({ src, publicUrl, onTime }, ref) => {
  const { L } = useApp();
  const audioRef = useRef(null);
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoke;
    const load = publicUrl ? fetch(publicUrl).then((r) => { if (!r.ok) throw new Error(); return r.blob(); }) : api.get(src, { responseType: "blob" }).then((r) => r.data);
    load
      .then((blob) => {
        revoke = URL.createObjectURL(blob);
        setUrl(revoke);
      })
      .catch(() => setError(true));
    return () => revoke && URL.revokeObjectURL(revoke);
  }, [src, publicUrl]);

  useImperativeHandle(ref, () => ({
    seek: (t) => {
      if (!audioRef.current || !Number.isFinite(Number(t))) return;
      audioRef.current.currentTime = t;
      audioRef.current.play().catch(() => {});
    },
  }));

  if (error) return <p className="text-sm text-slate-500" data-testid="audio-unavailable">{L("Audio tidak tersedia.", "Audio unavailable.")}</p>;
  if (!url)
    return (
      <div className="flex items-center gap-2 text-sm text-slate-500" data-testid="audio-loading">
        <Loader2 size={16} className="animate-spin" /> {L("Memuatkan audio…", "Loading audio…")}
      </div>
    );
  return <audio ref={audioRef} controls src={url} className="w-full" data-testid="audio-player" onTimeUpdate={(e) => onTime?.(e.currentTarget.currentTime)} />;
});
